export default __webpack_public_path__ + "static/media/slackforgood.363ac5d1.png";